export default "__VITE_ASSET__nkGA9m$P__"